import { Editor, Toolbar } from 'ngx-editor';
import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  inject,
  Output,
  EventEmitter,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-article-highlight-model',
  templateUrl: './article-highlight-model.component.html',
  styleUrls: ['./article-highlight-model.component.scss'],
})
export class ArticleHighlightModelComponent implements OnInit {
  @ViewChild('addHighlightModal') addHighlightModal: TemplateRef<any>;

  @Output() hightlightTitleChange = new EventEmitter<any>();

  private modalService = inject(NgbModal);

  title: string;
  titleValue: string;
  id: string;

  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic']
  ];

  ngOnInit(): void {
    this.editor = new Editor();
  }

  open(e: any) {
    this.title = e.title;
    this.titleValue = e.titleValue;
    this.id = e.id;
    this.modalService.open(this.addHighlightModal, {
      windowClass: 'highlight-menu dropdown-outer-block',
      centered: true,
    });
  }

  addTitleToHightLightText(e: any) {
    this.hightlightTitleChange.emit({
      id: this.id,
      title: this.title,
      titleValue: this.titleValue,
    });
    this.modalService.dismissAll('cross click');
  }
}
